export const NARROW_BREAKPOINT = 280;
export const MOBILE_BREAKPOINT = 440;
